import Worker from "worker-loader!./sharedworker.js";
import EventBus from "../../utils/event_bus";
import isSharedWorker from "../../utils/is_shared_worker";

const validTimeframe = [
  "S15", //15 segundos
  "S30", //30 segundos
  "M1", //1 minuto
  "M2", //2 minutos
  "M5", //5 minutos
  "M10", //10 minutos
  "M15", //15 minutos
  "M30", //30 minutos
  "H1", //1 hora
  "T1000", //1.000 trades
  "V5000", //5.000 volumes
  "V10000", //10.000 volumes
];

let chosenWorker;
if (isSharedWorker) {
  const worker = new SharedWorker(((fn) => fn.match(/"(.*?)"/)[1])("" + Worker), {
    type: "module",
    name: "MD OnTick",
  });
  chosenWorker = worker.port;

  chosenWorker.start();
} else {
  chosenWorker = new Worker(((fn) => fn.match(/"(.*?)"/)[1])("" + Worker), {
    type: "module",
    name: "MD OnTick",
  });
}

// const MAX_COUNTER = 30;
// const counter = {
//   count: 0,
//   increment() {
//     this.count++;
//   },
//   get() {
//     return this.count;
//   },
// };

// Analisa as mensagens recebidas pelo websocket
const handleMessages = (e) => {
  //
  // counter.increment();
  // if (counter.get() % MAX_COUNTER === 0) console.clear();
  // console.log("handleMessages", e.data);
  //
  if (e.data.type) {
    // console.log(e.data.type);

    EventBus.$emit(e.data.type, e.data);
    return;
  } else if (e.data.payloadString?.includes("LIST_INVESTMENT_IDS")) {
    // console.log("LIST_INVESTMENT_IDS");
    return;
  } else if (e.data.payloadString?.split(":")[0] === "L1") {
    // Market data cheat sheet: [msg_type]:[bid_price]:[bid_volume]:[ask_price]:[ask_volume]:[last_price]
    const [msg_type, bid_price, bid_volume, ask_price, ask_volume, last_price] = e.data.payloadString.split(":");
    const symbol = e.data.topic.split("/")[1];
    const data = {
      timeframe: "L1",
      msg_type,
      bid_price,
      bid_volume,
      ask_price,
      ask_volume,
      last_price,
    };
    let md = {
      symbol,
      data,
    };
    // console.log("MARKET_DATA", e.data.destinationName, md);
    EventBus.$emit("MARKET_DATA", md);
    return;
  } else if (validTimeframe.includes(e.data.payloadString?.split(":")[0])) {
    const [timeframe, time, open, high, low, close, trades, volume] = e.data.payloadString.split(":");
    // console.log("MARKET_DATA", e.data.destinationName, {
    //   symbol: e.data.topic.split("/")[1],
    //   data: {
    //     timeframe: timeframe,
    //     time: Number.parseInt(time, 10),
    //     open: Number.parseFloat(open),
    //     high: Number.parseFloat(high),
    //     low: Number.parseFloat(low),
    //     close: Number.parseFloat(close),
    //     trades: Number.parseInt(trades, 10),
    //     volume: Number.parseInt(volume, 10),
    //   },
    // });
    // console.log("e....", e);
    EventBus.$emit("MARKET_DATA", {
      symbol: e.data.topic.split("/")[1],
      data: {
        timeframe: timeframe,
        time: Number.parseInt(time, 10),
        open: Number.parseFloat(open),
        high: Number.parseFloat(high),
        low: Number.parseFloat(low),
        close: Number.parseFloat(close),
        trades: Number.parseInt(trades, 10),
        volume: Number.parseInt(volume, 10),
      },
    });
    return;
  }
};

chosenWorker.onmessage = (e) => {
  handleMessages(e);
};

export default {
  sendMessage(e) {
    chosenWorker.postMessage(e);
  },
};
